import { render } from "./CmpContacto.vue?vue&type=template&id=5287c925&scoped=true"
import script from "./CmpContacto.vue?vue&type=script&lang=js"
export * from "./CmpContacto.vue?vue&type=script&lang=js"

import "./CmpContacto.vue?vue&type=style&index=0&id=5287c925&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5287c925"]])

export default __exports__